// extracted by mini-css-extract-plugin
module.exports = {"imagePanel":"imagePanel-881dd7f4","titleWrap":"titleWrap-3dbbc6c3"};